import { useAuth } from '../lib/auth'

export default function LoginScreen() {
  const { login, isSigningIn } = useAuth()

  return (
    <div className="min-h-screen flex items-center justify-center bg-base-200 px-4">
      <div className="card w-full max-w-sm bg-base-100 shadow-xl border border-base-300">
        <div className="card-body items-center text-center gap-4">
          <img
            src="/mate-avatar.avif"
            alt="Mat-E"
            className="h-14 w-14 rounded-lg object-cover"
          />
          <div>
            <h1 className="text-xl font-bold">ASM Admin Console</h1>
            <p className="text-sm opacity-60 mt-1">Sign in to continue</p>
          </div>
          <button
            type="button"
            className="btn btn-primary w-full mt-2"
            onClick={login}
            disabled={isSigningIn}
          >
            {isSigningIn ? (
              <>
                <span className="loading loading-spinner loading-sm" />
                Signing in…
              </>
            ) : (
              'Sign in with ASM'
            )}
          </button>
        </div>
      </div>
    </div>
  )
}
